var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
let PlanTemplateRow = class PlanTemplateRow extends Vue {
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    removeLearningObjective() {
        this.$emit('remove', this.objective);
    }
    // #endregion
    // #region Async methods
    // #endregion
    // #region Getters & Setters
    get editorOptions() {
        return {
            placeholder: this.$t('student_plan.template.quill'),
            modules: {
                magicUrl: true,
                toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ['bold', 'italic', 'underline', 'link'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['clean'],
                ],
            },
        };
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], PlanTemplateRow.prototype, "objective", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], PlanTemplateRow.prototype, "showDeleteIcon", void 0);
PlanTemplateRow = __decorate([
    Component({
        components: {
            quillEditor,
        },
    })
], PlanTemplateRow);
export default PlanTemplateRow;
